import type { DrilldownField } from '../../contexts/DrilldownContext';

/**
 * How a drill-down grid cell prints a number.
 *
 * PPV-POLISH (spec 04 §4.1): a `line_money` column (the PPV drill's prices,
 * PPV and value, converted to the display currency) prints as money: exactly
 * the `decimals` the server rounded it to, with thousands separators
 * (`13,140.40`). The server sends both on the field (backend
 * `drilldown/line_money.py`), so the precision has one owner. Every other number
 * keeps the grid's rule: quantities to 3 decimals (`4.32`), a whole number over
 * 1,000 with separators.
 *
 * @param value - the cell's number
 * @param field - the column's field metadata, as the details response sends it
 * @returns the text the cell shows
 */
export function formatDrillNumber(value: number, field?: DrilldownField): string {
  if (field?.line_money && typeof field.decimals === 'number') {
    // `0 + value` turns -0 into 0, so a zero never prints as "-0.00".
    return (0 + value).toLocaleString(undefined, {
      minimumFractionDigits: field.decimals,
      maximumFractionDigits: field.decimals,
    });
  }
  if (Number.isInteger(value) && value > 1000) {
    return value.toLocaleString();
  }
  return value.toLocaleString(undefined, { maximumFractionDigits: 3 });
}
